import store from '~/store'

export default (to, from, next) => {
	if('auth/user' in store.getters){
			console.log("store.getters: ", store.getters);
		      if (store.getters['auth/user'].role !== 3 && store.getters['auth/user'].role !== 2) {
			            next({ name: 'summaries'})
			          }
		    }
	  else {
		      next()
		    }
}




// WEBPACK FOOTER //
// ./resources/js/middleware/admin.js